import React from "react";
import { motion } from "framer-motion";
import { ReactComponent as FacebookIcon } from "../Images/logo-facebook.svg";
import { ReactComponent as TiktokIcon } from "../Images/logo-tiktok.svg";
import { ReactComponent as SoundCloudIcon } from "../Images/logo-soundcloud.svg";
import { ReactComponent as LinkedInIcon } from "../Images/logo-linkedin.svg";
export default function Index({ container, item }) {
  return (
    <motion.div
      className="social-media"
      variants={container}
      animate="show"
      initial="hidden"
    >
      <motion.a
        href="https://www.facebook.com/KassetDawwar"
        target="_blank"
        rel="noopener noreferrer"
        variants={item}
      >
        <FacebookIcon />
      </motion.a>
      <motion.a
        href="https://www.tiktok.com/@kasset_dawwar"
        target="_blank"
        rel="noopener noreferrer"
        variants={item}
      >
        <TiktokIcon />
      </motion.a>
      <motion.a
        href="https://soundcloud.com/tuqa-abu-radi"
        target="_blank"
        rel="noopener noreferrer"
        variants={item}
      >
        <SoundCloudIcon />
      </motion.a>
      <motion.a
        href="https://www.linkedin.com/in/tuqa-abu-radi-70ab4a18a/"
        target="_blank"
        rel="noopener noreferrer"
        variants={item}
      >
        <LinkedInIcon />
      </motion.a>
    </motion.div>
  );
}
